import { init } from '@sentry/browser';
import * as Sentry from '@sentry/browser';

export function initSentry() {
  try {
    if (!process?.env?.REACT_APP_SENTRY_DSN) {
      console.log('Missing SENTRY DSN');
      return;
    }

    init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: ['leazard-js'],
          behaviour: 'drop-error-if-contains-third-party-frames',
        }),
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      denyUrls: [/googletagmanager\.com/i, /gtm\.js/i, /gtm-[A-Z0-9]+\.js/i],
    });
  } catch (error) {
    console.error(`Failed to initialize Sentry: ${error}`);
  }
}
